import React from 'react'

class SplitCard extends React.Component {
  render() {
    const {
      title,
    } = this.props

    return(
      <div className='card card-single'>
        <div className='card-header'>
          { title }
        </div>
        {this.props.children }
      </div>
    )
  }
}

export default SplitCard;
